import { DefaultSelect, Text } from "components";
import { SVGProps, TagSimpleIcon } from "components/icons";
import React from "react";
import {
  ServiceItemStyle,
  ServiceItemRightStyle,
  ServiceItemTitleStyle,
  ServiceIconStyle,
} from "../styles";

type Props = {
  title: string;
  subtitle?: string;
  Icons: React.FC<SVGProps>[];
  onSelect: (value: string) => void;
  value: string;
  options: { value: string; label: string }[];
  tag?: boolean;
  disabled?: boolean;
};
export const ServiceOptionsItem: React.FC<Props> = ({
  title,
  subtitle,
  Icons,
  options,
  value,
  disabled,
  tag,
  onSelect,
}) => {
  return (
    <div
      className={ServiceItemStyle}
      style={{
        cursor: disabled ? "not-allowed" : "pointer",
      }}
    >
      <div>
        <div className={ServiceItemTitleStyle}>
          {tag && (
            <TagSimpleIcon
              fill="highlight/6"
              style={{
                marginRight: "8px",
                marginBottom: "-3px",
                width: "24px",
                height: "24px",
              }}
            />
          )}
          <Text.Body marginBottom={0} marginTop={0}>
            {title}
          </Text.Body>
          {Icons.map((Icon, idx) => (
            <Icon key={idx} style={ServiceIconStyle} />
          ))}
        </div>
        {subtitle && <Text.BodyXS color="seconday">{subtitle}</Text.BodyXS>}
      </div>
      <div className={ServiceItemRightStyle}>
        <DefaultSelect
          options={options}
          defaultValue={value}
          onChange={onSelect}
          value={value}
          disabled={disabled}
        />
      </div>
    </div>
  );
};
